import React from 'react';

export default () => (
  <div className="drop-target__content">
    <img alt="plus" src="/img/icon/plus.svg" width="30px" />
  </div>
);
